import React from 'react';
import { render } from 'react-dom';

import MarketingPage, { Props } from 'js/courses/marketing/MarketingPage';
import Responsive from 'js/courses/shared/Responsive';
import globalAssign from 'js/utils/assign_global';

function renderCoursesMarketingPage(elementId: string, props: Props) {
  render(
    <Responsive>
      <MarketingPage {...props} />
    </Responsive>,
    document.getElementById(elementId),
  );
}

globalAssign('Aedu.CoursesMarketing', {
  renderCoursesMarketingPage: renderCoursesMarketingPage,
});
